export function ProposalPricingStatus({ error, onRetry }: { error?: string; onRetry: () => void }) {
  return (
    <div
      role={error ? 'alert' : 'status'}
      className="my-3 rounded-md border bg-white px-4 py-3 text-sm text-gray-700"
    >
      {error ? (
        <>
          {error}{' '}
          <button type="button" className="underline" onClick={onRetry}>
            Try again
          </button>
        </>
      ) : (
        'Updating your total… Please wait before approving.'
      )}
    </div>
  );
}
